export default "__VITE_ASSET__CZTTZb$O__"